import { computed } from 'mobx'
import type { GetCurrentUserFn } from '..'
import type { IamApi } from '../api/iam-api'

export class MultiFactorAuthStore {
  constructor(
    private readonly _api: IamApi,
    private readonly _getCurrentUser: GetCurrentUserFn,
  ) {}

  /**
   * Determines whether the user is enrolled in multi-factor authentication.
   */
  @computed
  get isUserEnrolled() {
    return this._getCurrentUser()?.mfaEnabled
  }

  /**
   * Gets an MFA enrollment URL.
   */
  async fetchEnrollmentUrl() {
    return this._api.authentication.enrollMFA().then((r) => r.enrollment_url)
  }
}
